module.exports = __webpack_public_path__ + "img/slide-1.d02d98ce.png";